import React, { useState, useEffect } from "react";
import TextArea from '../UI/TextArea';


const CustomSMSTextArea = ({ templateKey, type, register }) => {
    const [textValue, setTextValue] = useState("");
    const [charQty, setCharQty] = useState(160);
    const [cur, setCur] = useState(0);
    const handleClick = () => {
        setTimeout(() => {
            const textarea = document.querySelector("textarea");
            textarea.setSelectionRange(cur, cur);
            textarea.focus();
        }, 50);
    };
    const onBlur = (e) => {
        const textarea = document.querySelector("textarea");
        setCur(textarea.selectionStart);
    };
    return (
        <div>
            <div className="buttons-box" style={{ display: 'flex', flexWrap: 'wrap' }}>
                {templateKey[type] ? templateKey[type].map(function (object, i) {
                    return <div style={{ margin: '5px' }} key={`tag-${i}`} onClick={() => {
                        let char_num = `${textValue}{{ ${object} }}`.length;
                        if (char_num < 160) {
                            setTextValue(`${textValue.slice(0, cur)}{{ ${object} }}${textValue.slice(cur)}`);
                            setCur(`${textValue.slice(0, cur)}{{ ${object} }}`.length)
                            setCharQty(160 - `${textValue}{{ ${object} }}`.length);
                            handleClick()
                        }
                    }}><span className="responded general">{object}</span></div>;
                }) : ''}
            </div>
            <TextArea value={textValue} maxLength={160} onBlur={onBlur} onFocus={(e) => e.target.setSelectionRange(cur, cur)} onChange={(e) => {
                setTextValue(e.target.value);
                setCharQty(160 - e.target.value.length);
                setCur(e.target.selectionStart);
            }} register={register()} required={true} name='body' />
            <span>Content limited to 160 characters (including spaces), remaining: {charQty}</span>
        </div>
    );
}

export default CustomSMSTextArea;